import React from 'react';
import useNetworkStatus from '../hooks/useNetworkStatus';

const LoadingOverlay = ({ 
  isLoading, 
  message = 'در حال بارگذاری...', 
  showSpinner = true,
  className = '',
  zIndex = 'z-50',
  showNetworkStatus = true
}) => {
  const { isOnline, isSlowConnection, connectionSpeed } = useNetworkStatus();
  
  if (!isLoading) return null;

  // Determine message based on network status
  let displayMessage = message;
  let networkIndicator = null;
  
  if (showNetworkStatus) {
    if (!isOnline) {
      displayMessage = 'اتصال اینترنت قطع است...';
      networkIndicator = (
        <div className="mt-2 px-3 py-1 bg-red-100 text-red-700 rounded-full text-sm">
          آفلاین
        </div>
      );
    } else if (isSlowConnection) {
      displayMessage = `${message} (اتصال کند - لطفاً صبر کنید)`;
      networkIndicator = (
        <div className="mt-2 px-3 py-1 bg-yellow-100 text-yellow-700 rounded-full text-sm">
          اتصال کند - {connectionSpeed}
        </div>
      );
    } else {
      networkIndicator = (
        <div className="mt-2 px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm">
          اتصال خوب - {connectionSpeed}
        </div>
      );
    }
  }

  return (
    <div className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center ${zIndex} ${className}`} style={{ pointerEvents: 'auto' }}>
      <div className="bg-white p-8 rounded-2xl shadow-xl text-center max-w-md w-full mx-4 transform transition-all duration-300 ease-out scale-100 opacity-100 ring-1 ring-gray-200">
        {showSpinner && (
          <div className="mb-4">
            <svg className="animate-spin h-12 w-12 text-black mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          </div>
        )}
        <p className="text-gray-700 font-medium text-lg">{displayMessage}</p>
        
        {/* Network Status Indicator */}
        {networkIndicator}
        
        {/* Progress Bar */}
        <div className="mt-4 h-1.5 bg-gray-200 rounded-full overflow-hidden">
          <div 
            className={`h-full ${isSlowConnection ? 'bg-yellow-500' : 'bg-black'} animate-pulse transition-colors duration-300`} 
            style={{ width: isSlowConnection ? '30%' : '60%' }}
          ></div>
        </div>
        
        {/* Additional Info for Slow Connections */}
        {isSlowConnection && (
          <p className="text-xs text-gray-500 mt-3">
            اتصال اینترنت شما کند است. عملیات ممکن است بیشتر طول بکشد.
          </p>
        )}
        
        {!isOnline && (
          <p className="text-xs text-red-500 mt-3">
            لطفاً اتصال اینترنت خود را بررسی کنید.
          </p>
        )}
      </div>
    </div>
  );
};

export default LoadingOverlay; 